export const bannerAnimatedClasses = {
  grainImage: 'banner--grain-image',
}

export type GradientPoint = {
  /** RGB colour tuple */
  color: [number, number, number]
  /** Normalised [0–1] destination position on the canvas */
  finalX: number
  finalY: number
  /** Radius as a fraction of Math.max(W, H) */
  radius: number
  opacity: number
}

export type EntryTiming = {
  /** Total travel duration in ms for this point */
  duration: number
  /** Delay before this point starts moving */
  delay: number
}

// ── Config ────────────────────────────────────────────────────────────────────

export const ANIMATION_CONFIG = {
  // All points start from this position (top-right corner) before fanning out
  startX: 0.92,
  startY: 0.05,
  // Base entry duration and per-point stagger (ms)
  entryDuration: 4500,
  entryStagger: 700,
  // Subtle idle drift applied after each point settles at its final position
  breathingEnabled: true,
  breathingRange: 0.015,
}

// ── Gradient points ───────────────────────────────────────────────────────────

export const GRADIENT_POINTS: GradientPoint[] = [
  { color: [169, 190, 195], finalX: 0.82, finalY: 0.05, radius: 0.45, opacity: 0.65 },
  { color: [28, 83, 108], finalX: 0.35, finalY: 0.28, radius: 0.55, opacity: 0.85 },
  { color: [11, 48, 67], finalX: 0.62, finalY: 0.55, radius: 0.5, opacity: 0.8 },
  { color: [10, 22, 30], finalX: 0.52, finalY: 0.8, radius: 0.5, opacity: 0.9 },
  { color: [23, 25, 25], finalX: 0.34, finalY: 0.95, radius: 0.45, opacity: 0.9 },
]
